import { PWARewardResponse, PWARewardStatusResponse } from "interfaces/pwa";
import { pwaAPI } from "redux/apis/pwa";
import { sortWithSpecificId } from "utils/sort";
import useRewardsById from "hooks/useRewardsById";
import { usePWAInstall } from "../hooks/usePWAInstall";
import { useEffect, useMemo } from "react";
import { useWebStoreContext } from "contexts";
import { useEnvContext } from "contexts/EnvProvider";
import { FeaturesFlags } from "helpers";
import HomeView from "./HomeView";
import MegaMenuView from "./MegaMenuView";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";

export const PWABanner = ({ from }: { from: string }) => {
	const { isFeatureFlagEnabled } = useEnvContext();
	const isPWAEnabled = isFeatureFlagEnabled(FeaturesFlags.PWA);
	const { data: pwaReward }: { data?: PWARewardResponse } =
		pwaAPI.endpoints.getRewardPWA.useQueryState("");

	const { data: pwaRewardStatus }: { data?: PWARewardStatusResponse } =
		pwaAPI.endpoints.getRewardStatusPWA.useQueryState("");
	const { authToken } = useWebStoreContext();

	const { open } = usePopUpsV2();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const displayRewards = useRewardsById(pwaReward?.rewardId as string);

	const orderedRewards = sortWithSpecificId(
		displayRewards,
		"loyalty_points",
		"last"
	);
	const { canInstall, installed, promptInstall } = usePWAInstall();

	const { isAndroid } = useMemo(() => {
		if (typeof window === "undefined") {
			return { isAndroid: false };
		}
		const ua = window.navigator.userAgent || "";
		return {
			isAndroid: /android/i.test(ua)
		};
	}, []);

	const shouldShowBanner =
		isPWAEnabled &&
		!installed &&
		pwaReward?.rewardId &&
		pwaRewardStatus &&
		!pwaRewardStatus?.pwaReward?.rewardId &&
		authToken; //&& !dismissed;

	useEffect(() => {
		if (shouldShowBanner) {
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "pwa_banner_shown",
				event_type: "pwa_install",
				action: "banner_shown",
				source: "pwa_install",
				page_location: from.replace(/-/g, "_")
			});
		}
	}, [shouldShowBanner, from, reportPlaygamiEvent]);

	const handleMainClick = async () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "pwa_banner_add_clicked",
			event_type: "pwa_install",
			action: "banner_click",
			source: "pwa_install",
			page_location: from.replace(/-/g, "_")
		});

		if (isAndroid && canInstall) {
			await promptInstall();
			return;
		}
		//dispatch(onOpenPopUp("pwa-info-popup"));
		open({
			variant: "pwa-info-popup",
			id: "pwa-info-popup",
			replaceIfExists: true
		});
	};

	if (!shouldShowBanner) {
		return null;
	}

	return (
		<>
			{from === "landing-page" && (
				<HomeView rewards={orderedRewards} onClick={handleMainClick} />
			)}
			{from === "mega-menu" && (
				<MegaMenuView rewards={orderedRewards} onClick={handleMainClick} />
			)}
		</>
	);
};
